module.exports = window;


//////////////////
// WEBPACK FOOTER
// external "window"
// module id = 2477
// module chunks = 63